// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import inboxApi from "./api/inboxApi";
import { abreSoOSite } from "./lib/qualPacote";
import { tokenGuardado } from "./lib/sessao";

(function migrateOrgKeys() {
  if (typeof window === "undefined") return;
  try {
    const storage = window.localStorage;
    if (!storage) return;
    const legacy = ["org_id", "active_org_id", "activeOrgId"];
    const existing = storage.getItem("orgId");
    if (!existing) {
      const firstLegacy = legacy.map((key) => storage.getItem(key)).find((value) => value);
      if (firstLegacy) storage.setItem("orgId", firstLegacy);
    }
    legacy.forEach((key) => storage.removeItem(key));
  } catch {}
})();

if (typeof window !== "undefined") {
  window.inboxApi = window.inboxApi || inboxApi;
}

if (process.env.NODE_ENV !== "production") {
  try { require("./debug/installDebug"); } catch {}
}

const container = document.getElementById("root");
if (!container) throw new Error('Elemento <div id="root" /> não encontrado em public/index.html');

// ⚠️ DOIS PACOTES, ESCOLHIDOS ANTES DE BAIXAR (ver lib/qualPacote.js). O `import()`
// dinâmico é o que faz o empacotador separar: quem abre a landing não baixa as 76 telas
// do sistema. Os provedores do app (login, organização, plano, presença) foram para
// AppCompleto.jsx pelo mesmo motivo.
const soOSite = abreSoOSite({
  hostname: window.location.hostname,
  pathname: window.location.pathname,
  token: tokenGuardado(),
});
const carregar = soOSite
  ? import(/* webpackChunkName: "site" */ "./Site")
  : import(/* webpackChunkName: "app" */ "./AppCompleto");

const root = createRoot(container);
carregar.then(({ default: Raiz }) => {
  root.render(
    <React.StrictMode>
      <Raiz />
    </React.StrictMode>
  );
});
